var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 14C7.456 14 0 15.872 0 19.6V22.4H22.4V19.6C22.4 15.872 14.944 14 11.2 14ZM3.744 19.2C5.088 18.272 8.336 17.2 11.2 17.2C14.064 17.2 17.312 18.272 18.656 19.2H3.744ZM11.2 11.2C14.288 11.2 16.8 8.688 16.8 5.6C16.8 2.512 14.288 0 11.2 0C8.112 0 5.6 2.512 5.6 5.6C5.6 8.688 8.112 11.2 11.2 11.2ZM11.2 3.2C12.528 3.2 13.6 4.272 13.6 5.6C13.6 6.928 12.528 8 11.2 8C9.872 8 8.8 6.928 8.8 5.6C8.8 4.272 9.872 3.2 11.2 3.2ZM22.464 14.096C24.32 15.44 25.6 17.232 25.6 19.6V22.4H32V19.6C32 16.368 26.4 14.528 22.464 14.096ZM20.8 11.2C23.888 11.2 26.4 8.688 26.4 5.6C26.4 2.512 23.888 0 20.8 0C19.936 0 19.136 0.208 18.4 0.56C19.408 1.984 20 3.728 20 5.6C20 7.472 19.408 9.216 18.4 10.64C19.136 10.992 19.936 11.2 20.8 11.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.131d0efa.svg";
export { ForwardRef as ReactComponent };